import { render, staticRenderFns } from "./DataFormViewerDialog.vue?vue&type=template&id=2724a81f&"
import script from "./DataFormViewerDialog.vue?vue&type=script&lang=js&"
export * from "./DataFormViewerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports